module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="loading"></div>\n';
 if (canEdit) { 
__p+='\n<button class="btn btn-primary btn-sm" id="new-person">New Relationship</button>\n';
 } 
__p+='\n<table class="table table-hover top-margined">\n    <head>\n        <thead>\n        <tr>\n            <th>Person</th>\n            <th>Date From</th>\n            <th>Date To</th>\n            <th>Contacts</th>\n            <th></th>\n            <th></th>\n        </tr>\n        </thead>\n    </head>\n    <tbody></tbody>\n</table>\n\n<div id="organization-person"></div>\n<div id="org-person-delete-confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/organizations/organization-persons-view.html
// module id = 283
// module chunks = 0